import React, { useEffect } from "react";
import { batch, useDispatch, useSelector } from "react-redux";
import GridTable from "../Common/GridTable";
import { useNavigate } from "react-router-dom";
import { ColDef, ValueFormatterParams } from "@material-ui/data-grid";
import { setResponseMessage } from "features/admin/adminSlice";
import {
  selectAllInstallations,
  fetchAllInstallations,
  deleteInstallation,
} from "features/admin/Installations/installationAdminSlice";
import { selectLoading } from "features/admin/Products/productsAdminSlice";
import DualPrice from "components/Price";

interface AllInstallationTableProps {}
const columns: ColDef[] = [
  { sortable: false, field: "from_power", headerName: "От (BTU)", width: 300 },
  { sortable: false, field: "to_power", headerName: "До (BTU)", width: 300 },
  {
    sortable: false,
    field: "airConditionType",
    headerName: "Тип на климатик",
    width: 300,
  },
  {
    sortable: false,
    field: "price",
    headerName: "Цена",
    width: 300,
    renderCell: (params: any) => (
      <DualPrice bgn={params.value} eur={params.row.price_eur} showBgn />
    ),
  },
];

const InstallationTable: React.FC<AllInstallationTableProps> = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const installations = useSelector(selectAllInstallations);
  const isLoading = useSelector(selectLoading);
  useEffect(() => {
    dispatch(fetchAllInstallations());
  }, [dispatch]);

  const add = () => {
    navigate("/installations/add");
  };
  const refresh = () => {
    dispatch(fetchAllInstallations());
  };
  const remove = (ids: string[]) => {
    ids.forEach((id: string) => {
      const _refId = installations.find(
        (item: { id: number }) => item.id === parseInt(id)
      )?.refId;
      _refId &&
        batch(() => {
          dispatch(setResponseMessage({ message: "", hasError: false }));
          dispatch(deleteInstallation(_refId));
        });
    });
    dispatch(fetchAllInstallations());
  };

  const edit = (id: string) => {
    const _refId = installations.find(
      (item: { id: number }) => item.id === parseInt(id)
    )?.refId;
    _refId && navigate(`/installations/edit/${_refId}`);
  };

  return (
    <GridTable
      add={add}
      refresh={refresh}
      remove={remove}
      edit={edit}
      data={installations}
      columns={columns}
      isLoading={isLoading}
      searchProperty="title"
    />
  );
};

export default InstallationTable;
